import styled from "styled-components"

import { getSteps } from "./content"
import { Eyebrow, mobileBreakpoint, textDark, useReferralAgent } from "./shared"

const StepsSection = styled.section`
  max-width: 1088px;
  margin: 0 auto;
  padding: 56px 24px 80px;
  /* breathing room above the title when reached via the header anchor links */
  scroll-margin-top: 48px;

  h2 {
    color: ${textDark};
    font-size: 26px;
    font-weight: 500;
    line-height: 1.5;
    letter-spacing: -1.04px;
  }
`

const StepsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  margin-top: 30px;

  @media only screen and (width <= ${mobileBreakpoint}) {
    grid-template-columns: 1fr;
    gap: 28px;
  }
`

const StepNumber = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  /* primary/20 — the pale tint of the number's primary/200 */
  background: rgb(45 178 200 / 12%);
  color: #2db2c8;
  font-size: 1rem;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.64px;
`

const Step = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  h3 {
    margin: 0;
    color: ${textDark};
    font-size: 1rem;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.64px;
  }

  p {
    margin: 6px 0 0;
    color: #64748b;
    font-size: 0.875rem;
    line-height: 1.65;
  }
`

export const Steps = () => {
  const agent = useReferralAgent()
  const steps = getSteps(agent?.name.split(" ")[0] ?? "your agent")

  return (
    <StepsSection id="how-it-works">
      <Eyebrow>How it works</Eyebrow>
      <h2>Three easy steps.</h2>
      <StepsGrid>
        {steps.map((step, index) => (
          <Step key={step.title}>
            <StepNumber>{index + 1}</StepNumber>
            <div>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </div>
          </Step>
        ))}
      </StepsGrid>
    </StepsSection>
  )
}
